module.exports = __webpack_public_path__ + "img/James Whitehurst on Board of Visitors, 1972.4db72c50.jpg";